import { RouteObject } from "react-router-dom";
import { CreateSeries } from "../features/series/pages/create.page";
import { ViewSeries } from "../features/series/pages/view.page";
import { ViewEpisodes } from "../features/series/pages/view-episodes.page";
import { ViewCastCrew } from "../features/series/pages/cast-crew.page";
import { AllSeries } from "../features/series/pages/all.page";
import { WithAuth } from "../components/layout/with-auth/with-auth.component";
import { DistributeSeries } from "../features/series/pages/distribute.page";

export const seriesRoutes: RouteObject[] = [
  {
    path: "/s",
    element: (
      <WithAuth>
        <AllSeries />
      </WithAuth>
    ),
  },
  {
    path: "/s/create",
    element: (
      <WithAuth>
        <CreateSeries />
      </WithAuth>
    ),
  },
  {
    path: "/s/:id/edit",
    element: (
      <WithAuth>
        <CreateSeries editing />
      </WithAuth>
    ),
  },
  {
    path: "/s/:id",
    element: (
      <WithAuth>
        <ViewSeries />
      </WithAuth>
    ),
  },
  {
    path: "/s/:id/episodes",
    element: (
      <WithAuth>
        <ViewEpisodes />
      </WithAuth>
    ),
  },
  {
    path: "/s/:id/cast-crew",
    element: (
      <WithAuth>
        <ViewCastCrew />
      </WithAuth>
    ),
  },
  {
    path: "/s/:id/distribute",
    element: (
      <WithAuth>
        <DistributeSeries />
      </WithAuth>
    ),
  },
];
